import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from './service/app.layout.service';
import { HeaderService } from '@app/core/directives/header-directive/header.service';
import { AuthServices } from '../services/auth.services';
import { Router } from '@angular/router';
import { SearchModalComponent } from '../components/search-modal/search-modal.component';
import { DialogService } from 'primeng/dynamicdialog';
import { getOppositeTheme, isDarkTheme } from '@app/core/config/theme.config';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
})
export class AppTopBarComponent implements OnInit {
  items!: MenuItem[];
  userFullName = 'Caricamento...';

  @ViewChild('menubutton') menuButton!: ElementRef;

  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

  @ViewChild('topbarmenu') menu!: ElementRef;

  constructor(
    public layoutService: LayoutService,
    public headerService: HeaderService,
    private authService: AuthServices,
    private router: Router,
    private dialog: DialogService,
  ) {}

  ngOnInit() {
    // Load user data with simpler approach
    this.loadUserName();
  }

  loadUserName() {
    // First try with basic user data
    this.authService.user().subscribe((user) => {
      this.userFullName = user.email;
    });
  }

  toggleDarkMode() {
    this.layoutService.config.update((state) => {
      const oppositeTheme = getOppositeTheme(state.theme);
      const newDarkTheme = isDarkTheme(oppositeTheme);
      const newColorScheme = newDarkTheme ? 'dark' : 'light';

      return {
        ...state,
        theme: oppositeTheme,
        darkTheme: newDarkTheme,
        colorScheme: newColorScheme,
      };
    });
  }

  onLogout() {
    this.authService.logout();
  }

  onProfile() {
    this.router.navigate(['/profile']);
  }

  openSearch() {
    this.dialog.open(SearchModalComponent, {
      width: '75%',
      height: '80%',
      closable: true,
      closeOnEscape: true,
      dismissableMask: true,
      header: 'Cerca',
    });
  }
}
